import axios from '@axios'

/**
 * ÍNDICE
 * {@link getPaymentMethods} - Obtener métodos de pago
 */

/**
 * 
 * @param {*} queryParams 
 * @returns {Promise} response
 */

export const getPaymentMethods = function () {
    try {
        return new Promise((resolve, reject) => {
                    axios
                        .get('/payment-methods')
                        .then(response => resolve(response))
                        .catch(error => reject(error))
                })
    }  catch (error) {
        return error
    }
}

    

